import { nextTick } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import { showDialog } from "vant";
import { validateLstToken, clearTokenCheckCache } from "@/utils/lstTokenGate";
import { getLstToken, clearLstSession } from "@/utils/lstSessionStorage";
import { startRouteLoading, stopRouteLoading } from "@/utils/pageLoading";
import { getPrimaryColor } from "@/utils/cssVars";
const PUBLIC_PATHS = ["/", "/more"];
const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: "/", component: () => import("@/views/Home.vue") },
        { path: "/holdings", component: () => import("@/views/Holdings.vue") },
        {
            path: "/trade",
            component: () => import("@/views/PurchaseShelves.vue")
        },
        {
            path: "/purchase",
            redirect: (to) => ({
                path: "/trade",
                query: { ...to.query, sub: to.query.sub || "purchase" }
            })
        },
        {
            path: "/shelves",
            redirect: (to) => ({
                path: "/trade",
                query: { ...to.query, sub: to.query.sub || "shelves" }
            })
        },
        { path: "/announcements", component: () => import("@/views/Announcements.vue") },
        {
            path: "/price-monitor",
            name: "PriceMonitor",
            component: () => import("@/views/Pricemonitor.vue"),
            meta: { title: "\u4EF7\u683C\u76EF\u76D8", requiresAuth: true }
        },
        {
            path: "/trade-monitor",
            name: "TradeMonitor",
            component: () => import("@/views/Trademonitor.vue"),
            meta: { title: "\u6210\u4EA4\u76D1\u63A7", requiresAuth: true }
        },
        {
            path: "/price-chart",
            name: "PriceChart",
            component: () => import("@/views/PriceChart.vue"),
            meta: { title: "\u884C\u60C5\u4E2D\u5FC3", requiresAuth: true }
        },
        {
            path: "/trade-volume",
            name: "TradeVolume",
            component: () => import("@/views/TradeVolume.vue"),
            meta: { title: "\u4EA4\u6613\u91CF\u7EDF\u8BA1", requiresAuth: true }
        },
        {
            path: "/hall-of-fame",
            name: "HallOfFame",
            component: () => import("@/views/HallOfFame.vue"),
            meta: { title: "\u540D\u4EBA\u5802", requiresAuth: true }
        },
        { path: "/more", component: () => import("@/views/More.vue") },
        {
            path: "/daily-trading",
            name: "DailyTradingSummary",
            component: () => import("@/views/DailyTradingSummary.vue"),
            meta: { title: "\u5F53\u65E5\u4EA4\u6613\u6C47\u603B", requiresAuth: true }
        },
        {
            path: "/on-sale/:albumId",
            name: "OnSaleList",
            component: () => import("@/views/OnSaleList.vue")
        },
        {
            path: "/album-primary/:albumId",
            name: "AlbumPrimaryDetail",
            component: () => import("@/views/AlbumPrimaryDetail.vue"),
            meta: { title: "\u4E13\u8F91\u8BE6\u60C5" }
        },
        {
            path: "/product/:id",
            name: "ProductDetail",
            component: () => import("@/views/ProductDetail.vue")
        },
        { path: "/sale-record", component: () => import("@/views/SaleRecord.vue") },
        { path: "/wallet", component: () => import("@/views/Wallet.vue") },
        { path: "/user", component: () => import("@/views/UserCenter.vue") },
        {
            path: "/orders",
            name: "OrderList",
            component: () => import("@/views/OrderList.vue"),
            meta: { title: "\u6211\u7684\u8BA2\u5355" }
        },
        {
            path: "/wuyou-my-consign/:productId?",
            name: "WuyouMyConsignment",
            component: () => import("@/views/WuyouMyConsignment.vue"),
            meta: { title: "\u6211\u7684\u5BC4\u552E" }
        },
        {
            path: "/order/:orderId",
            name: "OrderDetail",
            component: () => import("@/views/OrderDetail.vue"),
            meta: { title: "\u8BA2\u5355\u8BE6\u60C5" }
        },
        { path: "/my-assets", component: () => import("@/views/MyAssets.vue") },
        {
            path: "/resell",
            name: "ProductResell",
            component: () => import("@/views/ProductResell.vue"),
            meta: { title: "\u5BC4\u552E", requiresAuth: true }
        },
        { path: "/market", component: () => import("@/views/Market.vue") },
        {
            path: "/data-hall",
            name: "DataHall",
            component: () => import("@/views/DataHall.vue"),
            meta: { title: "\u6570\u636E\u7EDF\u8BA1", requiresAuth: true }
        },
        {
            path: "/data-hall/album-prices",
            name: "DataHallAlbumPrices",
            component: () => import("@/views/DataHallAlbumPrices.vue"),
            meta: { title: "\u6210\u4EA4\u4EF7\u4F4D", requiresAuth: true }
        },
        {
            path: "/blind-collect",
            name: "BlindCollectList",
            component: () => import("@/views/BlindCollectList.vue"),
            meta: { title: "\u96c6\u5361", requiresAuth: true }
        },
        {
            path: "/activity-assistant",
            name: "ActivityAssistantConfig",
            component: () => import("@/views/ActivityAssistantConfig.vue"),
            meta: { title: "\u52A9\u624B\u5B9A\u65F6" }
        },
        {
            path: "/draw-activities",
            name: "DrawActivityList",
            component: () => import("@/views/DrawActivityList.vue"),
            meta: { title: "\u62BD\u7B7E\u6D3B\u52A8" }
        },
        {
            path: "/draw/:drawId",
            name: "DrawActivityDetail",
            component: () => import("@/views/DrawActivityDetail.vue"),
            meta: { title: "\u62BD\u7B7E\u6D3B\u52A8" }
        },
        {
            path: "/draw/:drawId/records",
            name: "DrawRecords",
            component: () => import("@/views/DrawRecords.vue"),
            meta: { title: "\u62BD\u7B7E\u8BB0\u5F55" }
        },
        {
            path: "/compose/:groupId",
            name: "ComposeList",
            component: () => import("@/views/ComposeActivityList.vue"),
            meta: { title: "\u5408\u6210\u6D3B\u52A8" }
        },
        {
            path: "/compose/synthetic/:activityId",
            name: "ComposeSynthetic",
            component: () => import("@/views/ComposeSyntheticDetail.vue"),
            meta: { title: "\u5408\u6210" }
        },
        {
            path: "/recast/:groupId",
            name: "RecastList",
            component: () => import("@/views/RecastActivityList.vue"),
            meta: { title: "\u7F6E\u6362\u6D3B\u52A8" }
        },
        {
            path: "/recast/synthetic/:activityId",
            name: "RecastSynthetic",
            component: () => import("@/views/RecastSyntheticDetail.vue"),
            meta: { title: "\u7F6E\u6362" }
        },
        {
            path: "/exchange/:groupId",
            name: "ExchangeList",
            component: () => import("@/views/RecastActivityList.vue"),
            meta: { title: "\u5151\u6362\u6D3B\u52A8" }
        },
        {
            path: "/exchange/synthetic/:activityId",
            name: "ExchangeSynthetic",
            component: () => import("@/views/RecastSyntheticDetail.vue"),
            meta: { title: "\u5151\u6362" }
        },
        {
            path: "/points-hub",
            name: "PointsHub",
            component: () => import("@/views/PointsHub.vue"),
            meta: { title: "\u79EF\u5206\u4E0E\u5151\u6362" }
        },
        {
            path: "/points-mall",
            name: "PointsMall",
            component: () => import("@/views/PointsMall.vue"),
            meta: { title: "\u79EF\u5206\u5546\u57CE" }
        },
        {
            path: "/points-mall/transactions",
            name: "PointsTransactionList",
            component: () => import("@/views/PointsTransactionList.vue"),
            meta: { title: "\u79EF\u5206\u660E\u7EC6" }
        },
        {
            path: "/points-mall/album/:albumId",
            name: "PointsAlbumDetail",
            component: () => import("@/views/PointsAlbumDetail.vue"),
            meta: { title: "\u5151\u6362\u8BE6\u60C5" }
        }
    ]
});
let alertShowing = false;
const showLoginDialog = (next) => {
    if (!alertShowing) {
        alertShowing = true;
        showDialog({
            title: "\u8BF7\u5148\u767B\u5F55",
            message: "Token \u65E0\u6548\u6216\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u5728\u9996\u9875\u767B\u5F55\u540E\u518D\u4F7F\u7528\u6B64\u529F\u80FD",
            confirmButtonText: "\u53BB\u767B\u5F55",
            confirmButtonColor: getPrimaryColor()
        }).then(() => {
            alertShowing = false;
        }).catch(() => {
            alertShowing = false;
        });
    }
    return next("/");
};
router.beforeEach(async (to, from, next) => {
    if (to.path !== from.path && from.matched.length > 0) {
        startRouteLoading();
    }
    if (PUBLIC_PATHS.includes(to.path)) {
        return next();
    }
    const token = getLstToken();
    if (!token) {
        return showLoginDialog(next);
    }
    try {
        const res = await validateLstToken();
        if (res.code === 1) {
            return next();
        }
        clearTokenCheckCache();
        clearLstSession();
        return showLoginDialog(next);
    }
    catch (e) {
        return next();
    }
});
router.afterEach((to, from) => {
    if (to.path !== from.path) {
        nextTick(() => {
            requestAnimationFrame(() => stopRouteLoading());
        });
    }
});
export default router;
